import { opaqueHex, STOCK } from '@/lib/brand-style';

// The green 3D renders in public/images that are repainted in a studio's button
// colour. Keyed by the name a page asks for; the value is the original file.
export const ILLUSTRATION_FILES = {
  'calendar-3d': 'calendar-3d.webp',
  'calendar-blank-3d': 'calendar-blank-3d.webp',
  'calendar-off-3d': 'calendar-off-3d.webp',
  'calendar-x-3d': 'calendar-x-3d.webp',
  'change-plan': 'change-plan.webp',
  'check-3d': 'check-3d.webp',
  'class-credits': 'class-credits.png',
  'class-pack-3d': 'class-pack-3d.png',
  'clock-3d': 'clock-3d.webp',
  'compass-3d': 'compass-3d.webp',
  'cone-3d': 'cone-3d.webp',
  'credit-card-3d': 'credit-card-3d.webp',
  'gift-card-3d': 'gift-card-3d.webp',
  'guest-pass-3d': 'guest-pass-3d.webp',
  'gym-bag-3d': 'gym-bag-3d.webp',
  'hourglass-3d': 'hourglass-3d.webp',
  'location-off-3d': 'location-off-3d.webp',
  'lock-3d': 'lock-3d.webp',
  login: 'login.webp',
  'new-customer-3d': 'new-customer-3d.webp',
  'plug-3d': 'plug-3d.webp',
  'refresh-3d': 'refresh-3d.webp',
  'single-class-3d': 'single-class-3d.png',
  'subscription-3d': 'subscription-3d.png',
  'waitlist-hourglass-3d': 'waitlist-hourglass-3d.webp',
} as const;

export type IllustrationName = keyof typeof ILLUSTRATION_FILES;

export const isIllustrationName = (value: string): value is IllustrationName =>
  Object.hasOwn(ILLUSTRATION_FILES, value);

// A painted file is cached for a year under its URL, so a change to the
// recolouring maths (brand-illustration.ts) or to an original above only
// reaches anyone once this moves on. illustrations.test.ts pins what each
// version was painted with.
export const ILLUSTRATION_VERSION = 'v10';

export const stockIllustrationSrc = (name: IllustrationName) =>
  `/images/${ILLUSTRATION_FILES[name]}`;

const STOCK_BUTTON_HEX = opaqueHex(STOCK.button);

// Null for the stock button and for anything that is no colour: those studios
// keep the green originals, so their pages are exactly what they were before
// recolouring existed.
export const recolourHex = (buttonColor: string | undefined): string | null => {
  const hex = opaqueHex(buttonColor);
  return hex === STOCK_BUTTON_HEX ? null : hex;
};

export const illustrationSrc = (
  name: IllustrationName,
  buttonColor: string | undefined
) => {
  const hex = recolourHex(buttonColor);
  return hex
    ? `/illustrations/${ILLUSTRATION_VERSION}/${hex}/${name}.webp`
    : stockIllustrationSrc(name);
};
